import { useEffect, useState } from "react";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const SuccessSubscriptionPageNewsletter = () => {
  const [tokenValid, setTokenValid] = useState("awaitConfirmation");

  useEffect(() => {
    handleFetch();
  }, []);

  async function handleFetch(e) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const email = params.get("email");

    const response = await fetch("/api/users/confirmationToken", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token,
        email,
      }),
    });
    if (response.status === 201) {
      setTokenValid("createdUserNewsletter");
    } else if (response.status === 404) {
      setTokenValid("errorCreatingNewsletter");
    } else if (response.status === 200) {
      setTokenValid("userAlreadyExists");
    } else {
      const error = await response.json();
      console.error("Error desconocido:", error.message);
      // Otra lógica para errores inesperados
    }
  }

  return (
    <div>
      <Seo title="Subscription Confirmation" path="/success-subscription-newsletter" noIndex />
      {tokenValid === "createdUserNewsletter" ? (
        <BoxInfoTemplate
          title="Subscription Succesfull"
          subTitle="GRACIAS"
          mainText="Success! You have subscribed to my newsletter! 😀."
          iconType="check"
          borderColor="green"
          showQuotes={false}
        />
      ) : tokenValid === "errorCreatingNewsletter" ? (
        <BoxInfoTemplate
          title="Subscription UnSuccesfull"
          subTitle="TRY AGAIN"
          mainText="Something happended and ! You have NOT subscribed to my newsletter! 😢"
          iconType=""
          borderColor="red"
          showQuotes={false}
        />
      ) : tokenValid === "userAlreadyExists" ? (
        <BoxInfoTemplate
          title="User Already Exists"
          subTitle="It´s done"
          mainText="You are already subscribed to my newsletter! 👌"
          iconType=""
          borderColor="yellow"
          showQuotes={false}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default SuccessSubscriptionPageNewsletter;
